import { Observable } from 'rxjs';

export type EntityType = any;

export interface ICrudService<T extends EntityType> {


	delete(entity: T): Observable<any>;
	deleteById(id: any): Observable<any>;
	getById(id: any): Observable<T>;
	loadAll(): Observable<T>;
	save(entity: T): Observable<T>;

}

export interface ICrudAsyncService<T extends EntityType> extends ICrudService<T> {


	deleteAsync(entity: T): Promise<void>;
	deleteByIdAsync(id: any): Promise<void>;
	getByIdAsync(id: any): Promise<T>;
	loadAllAsync(): Promise<T>;
	saveAsync(entity: T): Promise<T>;

}

